import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectNestedError } from 'services/error/selectors';

// Types
import { Namespace } from 'types';
import { AppState } from 'services/types';

export interface OwnProps {
    namespace: Namespace;
    uuid: string;
}

interface ConnectedProps {
    nestedError?: string;
}

type Props = OwnProps & ConnectedProps;

export class NestedErrorValue extends React.PureComponent<Props> {
    render(): string | null {
        const { nestedError } = this.props;
        if (!nestedError) {
            return null;
        }
        return nestedError;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nestedError: makeSelectNestedError()
});

export default connect(mapStateToProps)(NestedErrorValue);
